import { SETTINGS_DIALOG } from '../types';
import { TEST_DIALOG } from '../types';

export const showSettingsDialog = () => (dispatch) => {
  dispatch({ type: SETTINGS_DIALOG, payload: true });
}

export const hideSettingsDialog = () => (dispatch) => {
  dispatch({ type: SETTINGS_DIALOG, payload: null });
}

export const showTestDialog = () => (dispatch) => {
  dispatch({ type: TEST_DIALOG, payload: true });
}

export const hideTestDialog = () => (dispatch) => {
  dispatch({ type: TEST_DIALOG, payload: null });
}